export const QuestionType = {
    multiple_choice: "multiple_choice",
    single_choice: "single_choice",
    document_upload: "document_upload",
    image_upload: "image_upload",
    phone_number: "phone_number",
    invoice_image: "invoice_image",
    pan_number: "pan_number",
    time: "time",
    ratings: "ratings",
    text: "text",
    ifsc_code: "ifsc_code",
    invoice_date: "invoice_date",
    aadhaar_number: "aadhaar_number",
    account_number: "account_number",
    stock: "stock",
    location: "location",
    multiple_image: "multiple_image",
    date: "date",
    single_image: "single_image",
    dropdown: "dropdown",
    pin_code: "pin_code",
    e_signature: "e_signature",
    yes_or_no: "yes_or_no",
    retailer_phone_number: "retailer_phone_number",
    auditor_contact_number: "auditor_contact_number",
    upi_id: "upi_id",
    phone_number_without_otp: "phone_number_without_otp",
    number: "number",
    phone_number_with_otp: "phone_number_with_otp",
    email_address: "email_address",
    gst_number: "gst_number",
    upload_file:"upload_file",
    census_network: "census_network",
}

export const DeviceType = {
    MOBILE: "Mobile",
    TABLET: "Tablet",
    PC: "PC"
}